import { Box, IconButton, Typography } from '@material-ui/core';
import { DocumentTempPrint } from '../Sections/generator/print/DocumentTempPrint';
import MyIcon from './MyIcon';
import { generatePDF } from '../common';

const APPROVAL_STATUS = {
  PENDING: 0,
  MANAGER_APPROVED: 1,
  ACCOUNTANT_APPROVED: 2,
  FULLY_APPROVED: 3,
  REJECTED: -1,
};

export default function PrintStockOrder({
  company,
  printData,
  template,
  componentRef,
  handleReactPrint,
  isRTL,
  title,
  elementid,
  types,
  no,
  approvalStatus,
}: any) {
  const isApproved =
    approvalStatus === undefined ||
    approvalStatus === APPROVAL_STATUS.MANAGER_APPROVED ||
    approvalStatus === APPROVAL_STATUS.ACCOUNTANT_APPROVED ||
    approvalStatus === APPROVAL_STATUS.FULLY_APPROVED;

  const fullitems = printData?.ritems || [];
  const filtereditems = fullitems.filter((fit: any) =>
    types.includes(fit?.itemType),
  );
  const items = filtereditems.map((fi: any, index: any) => {
    return {
      ...fi,
      no: index + 1,
    };
  });
  const fprintData = {
    ...printData,
    title,
    items,
  };

  return (
    <>
      <Box
        color="primary"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#252B3B',
          height: 30,
          paddingLeft: isRTL ? undefined : 10,
          paddingRight: isRTL ? 10 : undefined,
          borderRadius: 5,
        }}
      >
        <Typography style={{ fontSize: 14, color: 'white' }}>
          {title}
        </Typography>
        {isApproved ? (
          <Box>
            <IconButton
              style={{ padding: 7, margin: 0, color: 'white' }}
              onClick={handleReactPrint}
            >
              <MyIcon icon="print" size={20} />
            </IconButton>
            <IconButton
              style={{ padding: 7, margin: 0, color: 'white' }}
              onClick={() => generatePDF({ no, template, element: elementid })}
            >
              <MyIcon icon="pdf" size={20} />
            </IconButton>
          </Box>
        ) : (
          <Typography
            style={{
              fontSize: 11,
              color: '#ff9800',
              fontWeight: 'bold',
              paddingRight: isRTL ? undefined : 10,
              paddingLeft: isRTL ? 10 : undefined,
            }}
          >
            {isRTL ? 'يتطلب اعتماد' : 'Requires approval'}
          </Typography>
        )}
      </Box>
      <div
        id={elementid}
        style={{
          position: 'absolute',
          left: '-999em',
          direction: 'ltr',
          width:
            template?.size === 'POS'
              ? '80mm'
              : template?.size === 'A5'
                ? '148mm'
                : '210mm',
        }}
      >
        <DocumentTempPrint
          company={company}
          data={fprintData}
          template={template}
          ref={componentRef}
          isRTL={isRTL}
        ></DocumentTempPrint>
      </div>
    </>
  );
}
